import { useMemo } from 'react';
import { formatCurrency, formatDate, currencySortingFn } from '../utils/formatters';
import { IntransitBasePage } from './IntransitBasePage';

export function IntransitArrivingPage() {
  const columns = useMemo(
    () => [
      {
        accessorKey: 'product_default_code',
        header: 'Product',
        cell: (info) => (
          <a href={info.row.original.product_url} target="_blank" rel="noopener noreferrer">
            {info.getValue() || '[No code]'}
          </a>
        ),
      },
      {
        accessorKey: 'product_name',
        header: 'Name',
      },
      {
          accessorKey: 'warehouse',
          header: 'Warehouse',
      },
      {
        header: 'PO',
        accessorKey: 'po_name',
        cell: (info) => (
            info.row.original.po_url ? (
                <a href={info.row.original.po_url} target="_blank" rel="noopener noreferrer">
                    {info.getValue()}
                </a>
            ) : info.getValue() || '-'
        ),
      },
      {
        accessorKey: 'product_uom_qty',
        header: 'Quantity',
      },
      {
        accessorKey: 'unit_price_from_po',
        header: 'Purchase price',
        sortingFn: currencySortingFn,
        cell: (info) => {
          const amount = info.getValue();
          if (amount === null || amount === undefined) return '-';
          return formatCurrency(amount);
        },
      },
      {
        accessorKey: 'scheduled_date',
        header: 'ETA',
        cell: (info) => {
          const val = info.getValue();
          if (!val) return '-';
          const color = info.row.original.eta_css?.match(/color:\s*(#[0-9a-fA-F]+);/)?.[1];
          return (
            <span style={{ color: color || 'inherit' }}>
              {formatDate(new Date(val), 'P')}
            </span>
          );
        },
      },
      {
        accessorKey: 'purchaser',
        header: 'Purchaser',
      },
      {
        accessorKey: 'partner',
        header: 'Supplier',
      },
    ],
    []
  );

  const globalFilterFn = (row, columnId, filterValue) => {
    const search = filterValue.toLowerCase();
    const productName = (row.original.product_name || '').toLowerCase();
    const productCode = (row.original.product_default_code || '').toLowerCase();
    const poName = (row.original.po_name || '').toLowerCase();
    const supplier = (row.original.partner || '').toLowerCase();
    
    return productName.includes(search) || 
           productCode.includes(search) || 
           poName.includes(search) || 
           supplier.includes(search);
  };

  return (
    <IntransitBasePage 
      mode="arriving" 
      label="Arriving Stock" 
      columns={columns} 
      globalFilterFn={globalFilterFn}
      searchHelp="Search by Product (Name/SKU), PO, or Supplier"
    />
  );
}
